// Load Jquery
global.$ = require('jquery');
global.jQuery = $;

import infinity from '@bilginpro/infinity.js';

require('bootstrap');


// Load app scripts
require('./app');
require('./infinity');

App.initTest = function() {
    var quizContainers = $('.infinity-item[data-completed=false]');

    quizContainers.each(function (_, container) {
        var quizContainer = $(container);
        var questionCount = parseInt(quizContainer.find('input[name=question_count]').val());

        quizContainer.find('.question-answer-wrapper').each(function (_, item) {
            $(item).find('.answer').click(function () {
                $(item).find('.answer').removeClass('chosen-answer');
                $(this).addClass('chosen-answer');

                checkTest();
            });
        });

        var checkTest = () => {
            var completed = quizContainer.attr('data-completed');
            var answeredCount = quizContainer.find('.chosen-answer').length;
            if (questionCount !== answeredCount) {
                quizContainer.find('.not-checked-answer-count').text(questionCount - answeredCount);
                quizContainer.find('.not-complete-message').removeClass('d-none');
                return false;
            }

            var points = 0;
            quizContainer.find('.chosen-answer').each(function () {
                points += parseInt($(this).attr('data-point'));
            });
            var threshold_to_show = 99999;
            quizContainer.find('.complete').each(function () {
                var threshold = parseInt($(this).attr('data-threshold'));
                if (points <= threshold && threshold <= threshold_to_show)
                    threshold_to_show = threshold;
            });
            quizContainer.find('.complete').addClass('d-none');
            quizContainer.find('.complete[data-threshold=' + threshold_to_show + ']').removeClass('d-none');
            quizContainer.find('.not-complete-message').addClass('d-none');
            quizContainer.attr('data-completed', true);
        }
    });
}

App.initTest();


// WEBPACK FOOTER //
// ./resources/assets/web/scripts/quiz.js